<template>
  <div v-if="!subGroupRegisterView" class="content-container">
    <search-comp @onSearch="fnSearchGroupList" @onReset="onReset">
      <div class="section-box">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col w-20">
                <div class="das-form-input">
                  <div class="label">Thông tin đoàn</div>
                  <div class="child-w-80">
                    <input
                      v-model="searchParams.info"
                      type="text"
                      placeholder="Nhập mã đoàn hoặc tên đoàn"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-col w-16">
                <div class="das-form-input">
                  <div class="label">Công ty, đại lý du lịch</div>
                  <div class="child-w-80">
                    <input v-model="searchParams.agent" type="text" />
                  </div>
                </div>
              </div>
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Ngày đến</div>
                  <div class="child-w-80">
                    <CalendarRange
                      v-model="firstArrival"
                      style="display: block"
                      mode="date"
                    />
                  </div>
                </div>
              </div>
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Ngày đi</div>
                  <div class="child-w-80">
                    <CalendarRange
                      v-model="lastDep"
                      style="display: block"
                      mode="date"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col w-60">
                <div class="das-form-input">
                  <div class="label">Trạng thái đoàn</div>
                  <div class="child-w-80">
                    <div class="checkbox-wrap pr-1">
                      <input
                        id="isRoomBooking"
                        v-model="searchParams.isRoomBooking"
                        type="checkbox"
                      />
                      <label for="isRoomBooking">Có khách đặt phòng</label>
                    </div>
                    <div class="checkbox-wrap pr-1">
                      <input
                        id="isRoomCancel"
                        v-model="searchParams.isCancel"
                        type="checkbox"
                      />
                      <label for="isRoomCancel">Đoàn bị hủy</label>
                    </div>
                    <div class="checkbox-wrap pr-1">
                      <input
                        id="isRoomCi"
                        v-model="searchParams.isRoomCi"
                        type="checkbox"
                      />
                      <label for="isRoomCi">Có khách đang ở</label>
                    </div>
                    <div class="checkbox-wrap pr-1">
                      <input
                        id="isRoomCo"
                        v-model="searchParams.isRoomCo"
                        type="checkbox"
                      />
                      <label for="isRoomCo">Có khách đã trả phòng</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div
        v-loading="masterGroupLoading"
        class="grid-scroll mt-10"
        style="padding: 10px; background: white; height: 300px"
      >
        <GridVx
          ref="masterGroupTable"
          dom-layout="scroll"
          :columns="masterGroupCols"
          :rows="masterGroupRows"
          :header-height-setter="headerHeightSetter"
          :is-header-height-setter="true"
          :default-col-def="defaultColDef"
          class="agGrid"
          :auto-size-cell="true"
          @selectionChanged="onSelectMasterGroup"
        />
      </div>
      <div class="grid-botton">
        <GridPaging
          target="masterGroupTable"
          :total-size="masterGroupPaging.totalPage"
          :page-num="masterGroupPaging.currentPage"
          @pageChanged="onPageChanged($event, 'masterGroupPaging')"
          @onPageSizeChange="onPageSizeChanged($event, 'masterGroupPaging')"
        />
      </div>
      <div class="button-containers">
        <button
          class="btn primary small"
          :disabled="!masterGroupRowSelected"
          @click="fnOpenMissionDialog"
        >
          Nhiệm vụ
        </button>
        <button
          :disabled="!masterGroupRowSelected"
          class="btn primary small"
          @click="dialogDepositVisible = true"
        >
          Đặt cọc
        </button>
        <!-- <button class="btn primary small">Thay đổi tất cả Folio</button>
        <button class="btn primary small">Phòng ảo</button> -->
        <!-- <button class="btn primary small">Thành viên</button> -->
        <!-- <button class="btn primary small">Xác nhận</button> -->
        <button
          class="btn primary small"
          :disabled="!masterGroupRowSelected"
          @click="handlePrintRegForm"
        >
          Phiếu đăng ký
        </button>
        <!--           :disabled="!masterGroupRowSelected || statusGroup" -->
        <button
          class="btn primary small"
          :disabled="!masterGroupRowSelected || !statusGroup"
          @click="fnOpenCancelGroupDialog"
        >
          Hủy đoàn
        </button>
        <!-- <button class="btn primary small">Sao chép</button> -->
        <button
          :disabled="!masterGroupRowSelected"
          class="btn primary small"
          @click="dialogRoomListVisible = true"
        >
          Danh sách phòng
        </button>
        <button
          :disabled="!masterGroupRowSelected"
          class="btn primary small"
          @click="changeGroupInfo"
        >
          Thay đổi đoàn
        </button>
        <button
          class="btn primary small"
          @click="$router.push({ path: '/cashier/post_transaction' })"
        >
          Thêm GD
        </button>
        <button
          :disabled="!masterGroupRowSelected"
          class="btn primary small"
          @click="redirectToGroupTransactions"
        >
          Giao dịch đoàn
        </button>
        <button class="btn primary small" @click="fnExportExcel">
          Xuất Excel
        </button>
      </div>
      <div class="das-layout gap-5">
        <div class="w-100">
          <div class="title-1">
            <span>ĐOÀN PHỤ</span>
            <span class="customer-name">{{
              masterGroupRowSelected?.name
            }}</span>
          </div>
          <div
            v-loading="subGroupLoading"
            class="grid-scroll table-custom-1"
            style="height: 300px; padding: 10px"
          >
            <!-- :auto-size-cell="true" -->
            <GridVx
              ref="agGrid"
              :columns="columns"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :rows="rows"
              :auto-size-cell="true"
              class="agGrid"
              :pinned-bottom-row-data="pinnedBottomRowData"
              @selectionChanged="onSelectSubGroup"
            />
          </div>
          <!-- <div class="grid-botton">
            <GridPaging
              target="agGrid"
              :page-size-option="[20, 50, 100]"
              :total-size="subGroupPaging.totalPage"
              :page-num="subGroupPaging.currentPage"
              @pageChanged="onPageChanged($event, 'subGroupPaging')"
              @onPageSizeChange="onPageSizeChanged($event, 'subGroupPaging')"
            />
          </div> -->
          <div class="button-containers">
            <button
              class="btn primary small"
              :disabled="
                !masterGroupRowSelected || masterGroupRowSelected?.status == 4
              "
              @click="onCreateSubGroup"
            >
              Tạo đoàn phụ mới
            </button>
            <button
              :disabled="
                !selectedSubGroup || masterGroupRowSelected?.status == 4
              "
              class="btn primary small"
              @click="onUpdateSubGroup"
            >
              Chi tiết đoàn phụ
            </button>
            <button
              :disabled="
                !selectedSubGroup || masterGroupRowSelected?.status == 4
              "
              class="btn primary small"
              @click="dialogUpdateRoomVisible = true"
            >
              Nhập DS phòng
            </button>
            <button
              :disabled="
                !selectedSubGroup || masterGroupRowSelected?.status == 4
              "
              class="btn primary small"
              @click="onDeleteSubGroup"
            >
              Xóa đoàn phụ
            </button>
          </div>
        </div>
      </div>
    </div>
    <GroupMasterMissionDialog
      :selected-data="masterGroupRowSelected"
      :dialog-visible="dialogMissionVisible"
      @closeDialog="handleCloseDialog('mission')"
    />
    <DepositDialog
      :selected-group-data="masterGroupRowSelected"
      :dialog-visible="dialogDepositVisible"
      @closeDialog="handleCloseDialog('deposit')"
    />
    <el-dialog
      title="Xác nhận hủy đoàn"
      :visible.sync="dialogCancelGroupVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="onCloseCancelGroup"
    >
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <InfoList
                :columns="4"
                :column-breakpoint-options="{
                  sm: 1,
                  md: 4
                }"
              >
                <InfoListLabel>Số dư</InfoListLabel>
                <InfoListValue>{{ groupBalance }}</InfoListValue>
              </InfoList>
              <div class="das-form-row">
                <div class="das-form-col w-50">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('field.reason') }}</div>
                    <validation-observer ref="cancelGroupFormValidator">
                      <validation-provider
                        rules="required"
                        :name="$t('field.reason')"
                      >
                        <select-with-search-table
                          style="width: 100%"
                          :rows="cancelReasonList"
                          :columns="cancelReasonColumns"
                          index-field="id"
                          :selected-index-field-value="cancelGroupExplaination"
                          :value="cancelGroupExplaination"
                          @selectionChanged="onSelectRowCancelReason"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedData }"
                          >
                            {{ selectedData?.desc }}
                          </template>
                        </select-with-search-table>
                      </validation-provider>
                    </validation-observer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small outline" @click="onCloseCancelGroup">
            Đóng
          </button>
          <button class="btn primary small" @click="confirmCancelGroup">
            Xác nhận
          </button>
        </div>
      </span>
    </el-dialog>
    <RoomListDialog
      :selected-data="masterGroupRowSelected"
      :dialog-visible="dialogRoomListVisible"
      :cancel-reason-list="cancelReasonList"
      @closeDialog="handleCloseDialog('roomList')"
    />
    <UpdateRoomListDialog
      :group-data="masterGroupRowSelected"
      :selected-data="selectedSubGroup"
      :dialog-visible="dialogUpdateRoomVisible"
      @closeDialog="handleCloseDialog('updateRoomBooking')"
    />
    <!-- @closeDialog="handleCloseDialog" -->
    <CustomerDisplayDialog
      :selected-data="selectedSubGroup"
      :dialog-visible="dialogCustomerDisplayVisible"
      @closeDialog="handleCloseDialog('displayCustomer')"
    />
  </div>
  <div v-else class="content-container">
    <div class="top-control-container">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onCancelSubGroup">
          Hủy
        </button>
        <button
          v-if="createSub"
          class="btn primary small"
          @click="onCreateUpdateSubGroup"
        >
          Lưu
        </button>
        <button
          v-if="!createSub"
          class="btn primary small"
          @click="onCreateUpdateSubGroup(false)"
        >
          Cập nhật
        </button>
        <button
          v-if="!createSub"
          class="btn primary small"
          @click="onCreateUpdateSubGroup(true)"
        >
          Cập nhật Tất cả
        </button>
      </div>
    </div>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Mã đoàn</div>
                  <input
                    v-model="masterGroupRowSelected.booking_code"
                    disabled
                    type="text"
                  />
                </div>
              </div>
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Tên đoàn</div>
                  <input
                    v-model="masterGroupRowSelected.name"
                    disabled
                    type="text"
                  />
                </div>
              </div>
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Trạng thái</div>
                  <input
                    v-model="masterGroupRowSelected.status_code"
                    disabled
                    type="text"
                  />
                </div>
              </div>
              <div class="das-form-col w-25"></div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Ngày đến đầu</div>
                  <input
                    v-model="masterGroupRowSelected.first_arrival_date"
                    disabled
                    type="text"
                  />
                </div>
              </div>
              <div class="das-form-col w-25">
                <div class="das-form-input">
                  <div class="label">Ngày đi cuối</div>
                  <input
                    v-model="masterGroupRowSelected.last_departure_date"
                    disabled
                    type="text"
                  />
                </div>
              </div>
              <div class="das-form-col w-25"></div>
              <div class="das-form-col w-25"></div>
            </div>
          </div>
        </div>
        <div class="das-form-container">
          <div class="das-form-title-container"></div>
          <hr />
          <div class="das-layout gap-5">
            <div class="l-w-70">
              <validation-observer ref="subGroupFormValidator">
                <div class="das-form-group">
                  <div class="das-form-group-title">Chi tiết đặt phòng</div>
                  <div class="das-form-row">
                    <div class="das-form-col w-50">
                      <div class="das-form-input">
                        <div class="label required">
                          {{ $t('field.arrivalDate') }}
                        </div>
                        <div class="das-layout gap-10">
                          <div class="l-w-66">
                            <validation-provider
                              rules="required"
                              :name="$t('field.arrivalDate')"
                              style="width: 100%"
                            >
                              <CalendarSelect
                                v-model="subGroupForm.arrive_date"
                                style="display: block; width: 100%"
                                mode="date"
                                :min-max="{
                                  min: this.$moment(
                                    masterGroupRowSelected.first_arrival_date,
                                    'DD-MM-YYYY'
                                  ).format('YYYY-MM-DD'),
                                  max: this.$moment(
                                    masterGroupRowSelected.last_departure_date,
                                    'DD-MM-YYYY'
                                  ).format('YYYY-MM-DD')
                                }"
                              />
                            </validation-provider>
                          </div>
                          <div class="l-w-33">
                            <TimePicker
                              v-model="subGroupForm.arrival_time"
                              hide-clear-button
                              format="HH:mm"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="das-form-col w-0"></div>
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('field.amountOfNight') }}
                        </div>
                        <validation-provider
                          :name="$t('field.amountOfNight')"
                          rules="required|number|min_value:0"
                        >
                          <input
                            v-model="numberOfNights"
                            v-numeric-only
                            type="number"
                            disabled
                          />
                        </validation-provider>
                      </div>
                    </div>
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('field.numOfAdult') }}
                        </div>
                        <validation-provider
                          rules="number"
                          :name="$t('field.numOfAdult')"
                          style="width: 100%"
                        >
                          <input
                            v-model="subGroupForm.num_of_adult"
                            type="number"
                            disabled
                            placeholder=""
                          />
                          <!-- :min="createSub ? null : oldSubGroup.num_of_room" -->
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <!-- </div>
                <div class="das-form-group"> -->
                  <div class="das-form-row">
                    <div class="das-form-col w-50">
                      <div class="das-form-input">
                        <div class="label required">
                          {{ $t('field.departureDate') }}
                        </div>
                        <div class="das-layout gap-10">
                          <div class="l-w-66">
                            <validation-provider
                              rules="required"
                              :name="$t('field.departureDate')"
                              style="width: 100%"
                            >
                              <CalendarSelect
                                v-model="subGroupForm.depart_date"
                                style="display: block; width: 100%"
                                mode="date"
                                :min-max="{
                                  min: this.$moment(
                                    masterGroupRowSelected.first_arrival_date,
                                    'DD-MM-YYYY'
                                  ).format('YYYY-MM-DD'),
                                  max: this.$moment(
                                    masterGroupRowSelected.last_departure_date,
                                    'DD-MM-YYYY'
                                  ).format('YYYY-MM-DD')
                                }"
                              />
                            </validation-provider>
                          </div>
                          <div class="l-w-33">
                            <TimePicker
                              v-model="subGroupForm.depart_time"
                              hide-clear-button
                              format="HH:mm"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="das-form-col w-0"></div>
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label">Số thẻ miễn phí</div>
                        <input
                          v-model.number="subGroupForm.num_of_free_card"
                          v-numeric-only
                          type="number"
                        />
                      </div>
                    </div>
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label">
                          {{ $t('field.numOfChildren') }}
                        </div>
                        <validation-provider
                          rules="number"
                          :name="$t('field.numOfChildren')"
                          style="width: 100%"
                        >
                          <input
                            v-model.number="subGroupForm.child_num"
                            v-numeric-only
                            type="number"
                            disabled
                            placeholder=""
                          />
                          <!-- :min="createSub ? null : oldSubGroup.num_of_guest" -->
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="das-form-row">
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label required">
                          {{ $t('field.currency') }}
                        </div>
                        <validation-provider
                          rules="required"
                          :name="$t('field.currency')"
                          style="width: 100%"
                        >
                          <el-select
                            v-model.number="subGroupForm.currency_id"
                            :default-first-option="true"
                            @change="onChangeCurrency"
                          >
                            <el-option
                              v-for="option in currencyOptions"
                              :key="option.id"
                              :label="option.code"
                              :value="option.id"
                            >
                            </el-option>
                          </el-select>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label">{{ 'Tỉ giá' }}</div>
                        <input
                          v-model.number="subGroupForm.exchange_rate"
                          v-numeric-only
                          type="number"
                          step="0.1"
                          style="width: 90%"
                        />
                      </div>
                    </div>
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label">
                          {{ 'Miễn phí/Nội bộ' }}
                        </div>
                        <el-select
                          v-model="subGroupForm.price_type"
                          placeholder=""
                          clearable
                        >
                          <el-option :value="1" label="Miễn phí"></el-option>
                          <el-option :value="2" label="Nội bộ"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label">Trẻ em dưới 5 tuổi</div>
                        <input
                          v-model.number="subGroupForm.u5_child_num"
                          v-numeric-only
                          disabled
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="das-form-row">
                    <div class="das-form-col w-50">
                      <div class="das-form-input">
                        <div class="label">Khách sạn</div>
                        <el-select
                          v-model="hotel_id"
                          filterable
                          clearable
                          @change="onChangeHotel"
                        >
                          <el-option
                            v-for="option in hotelOptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="das-form-col w-0"></div>
                    <div
                      class="das-form-col w-25 radio-checkbox-cell"
                      style="justify-content: start"
                    >
                      <!-- <div class="checkbox-wrap mb-2">
                        <input
                          id="lockChangeRoom"
                          v-model="subGroupForm.block_room"
                          type="checkbox"
                        />
                        <label for="lockChangeRoom">{{
                          $t('field.lockChangeRoom')
                        }}</label>
                      </div> -->
                    </div>

                    <!-- <div class="das-form-col w-5"></div> -->
                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label required">
                          {{ $t('field.numOfGuest') }}
                        </div>
                        <validation-provider
                          rules="required|number"
                          :name="$t('field.numOfGuest')"
                          style="width: 100%"
                        >
                          <input
                            v-model="subGroupForm.num_of_guest"
                            disabled
                            type="number"
                          />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="das-form-row">
                    <div class="das-form-col w-50">
                      <div class="das-form-input">
                        <div class="label required">
                          {{ $t('field.bookedRoomLevel') }}
                        </div>
                        <validation-provider
                          rules="required"
                          :name="$t('field.bookedRoomLevel')"
                          style="width: 100%"
                        >
                          <select-with-search-table
                            style="width: 100%"
                            :suppress-row-hover-highlight="true"
                            :rows="filteredRoomLevelOptions"
                            :columns="roomLevelOptionsCol"
                            row-class="room-level-row"
                            :get-row-class="getRowClass"
                            :search-fields="[
                              'room_type_name',
                              'room_level_code'
                            ]"
                            :value="subGroupForm.room_type_id"
                            :selected-index-field-value="
                              subGroupForm.room_type_id
                            "
                            index-field="room_level_id"
                            @selectionChanged="onChangeRoomLevel"
                          >
                            <template
                              v-slot:value="{ selectedValue: selectedData }"
                            >
                              {{ selectedData?.room_type_name }}
                            </template>
                          </select-with-search-table>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="das-form-col w-0"></div>
                    <div class="das-form-col w-25 radio-checkbox-cell">
                      <div
                        class="das-form-input"
                        style="justify-content: start"
                      >
                        <div
                          class="checkbox-wrap mb-2"
                          style="margin-right: 8px"
                        >
                          <input
                            id="nett"
                            v-model="subGroupForm.nett"
                            type="checkbox"
                          />
                          <label for="nett">{{ 'NETT' }}</label>
                        </div>
                        <div class="checkbox-wrap mb-2">
                          <input
                            id="buffet"
                            v-model="subGroupForm.is_bf"
                            type="checkbox"
                            :disabled="isBuffetDisabled"
                            @change="onChangeBuffet"
                          />
                          <label for="buffet">{{ 'Buffet' }}</label>
                        </div>
                      </div>
                    </div>

                    <div class="das-form-col w-25">
                      <div class="das-form-input">
                        <div class="label required">
                          {{ $t('field.numOfRoom') }}
                        </div>
                        <validation-provider
                          rules="required|between:1,100|number"
                          :name="$t('field.numOfRoom')"
                          style="width: 100%"
                        >
                          <input
                            v-model.number="subGroupForm.num_of_room"
                            v-numeric-only
                            type="number"
                            placeholder=""
                            disabled
                          />
                          <!-- :min="createSub ? null : oldSubGroup.num_of_room" -->
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </div>
              </validation-observer>
              <div class="das-form-group">
                <div class="das-form-group-title">Giá ngày</div>
                <BookingRoomDailyPriceTable
                  ref="BookingRoomDailyPriceTable"
                  :record-rows="subGroupForm.daily_price"
                  @updateRow="onUpdateDailyPriceRow"
                ></BookingRoomDailyPriceTable>
              </div>
              <div class="das-form-group">
                <div class="justify-space-between mb-1">
                  <div class="das-form-group-title">Phụ thu phí</div>
                  <button
                    class="btn small primary outline mb-2"
                    @click="onOpenBookingAddChargeDialog"
                  >
                    Chỉnh sửa
                  </button>
                </div>
                <booking-room-add-charge-table
                  :key="subGroupForm.room_type_id"
                  :record-rows="subGroupForm.sub_booking_group_surcharges"
                ></booking-room-add-charge-table>
              </div>
              <div class="das-form-group">
                <div class="justify-space-between mb-1">
                  <div class="das-form-group-title">Dịch vụ đặc biệt</div>
                  <button
                    class="btn small primary outline mb-2"
                    @click="dialogSpecialServiceVisible = true"
                  >
                    Chỉnh sửa
                  </button>
                </div>
                <BookingRoomServiceTable
                  :record-rows="subGroupForm.sub_booking_group_services"
                ></BookingRoomServiceTable>
              </div>
            </div>
            <div class="l-w-30">
              <div class="justify-space-between mb-1">
                <div class="title-1">Phân bổ phòng, khách</div>
                <button
                  class="btn primary outline small"
                  @click="onOpenAddRoomAndGuestDialog"
                >
                  Thêm
                </button>
              </div>
              <div class="grid-scroll mb-1" style="height: 350px">
                <GridVx
                  ref="AddRoomTable"
                  :context="context"
                  :columns="roomCols"
                  :rows="roomRows"
                  :auto-size-cell="true"
                  dom-layout="scroll"
                  class="agGrid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      append-to-body
      :title="$t('field.titleSpecialService')"
      :visible.sync="dialogSpecialServiceVisible"
      :close-on-click-modal="false"
      width="80%"
      @closed="dialogSpecialServiceVisible = false"
    >
      <BookingRoomServiceDialog
        ref="BookingRoomServiceDialog"
        :arrive-date="subGroupForm.arrive_date"
        :depart-date="subGroupForm.depart_date"
        :booking-room="subGroupForm"
      ></BookingRoomServiceDialog>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button class="btn primary small" @click="confirmSpecialService">
          Cập nhật
        </button>
        <button
          class="btn primary small outline"
          @click="dialogSpecialServiceVisible = false"
        >
          Đóng
        </button>
      </span>
    </el-dialog>
    <el-dialog
      append-to-body
      :title="$t('field.addCharge')"
      :visible.sync="isAddChargeDialogOpened"
      :close-on-click-modal="false"
      width="80%"
      @closed="isAddChargeDialogOpened = false"
    >
      <booking-room-add-charge-dialog
        :key="subGroupForm.room_type_id"
        ref="BookingRoomAddChargeDialog"
        :arrive-date="subGroupForm.arrive_date"
        :depart-date="subGroupForm.depart_date"
        :room-level-id="subGroupForm.room_type_id"
        :booking-room="subGroupForm"
      ></booking-room-add-charge-dialog>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button class="btn primary small" @click="onConfirmAddCharge">
          Cập nhật
        </button>
        <button
          class="btn primary small outline"
          @click="isAddChargeDialogOpened = false"
        >
          Đóng
        </button>
      </span>
    </el-dialog>
    <el-dialog
      append-to-body
      :title="$t('field.addRoom')"
      :visible.sync="dialogAddRoomAndGuestVisible"
      :close-on-click-modal="false"
      width="30%"
      @closed="dialogAddRoomAndGuestVisible = false"
    >
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col w-50">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.addNumOfRoom') }}
                    </div>
                    <validation-observer ref="cancelGroupFormValidator">
                      <validation-provider
                        rules="required"
                        :name="$t('field.addNumOfRoom')"
                      >
                        <input
                          v-model.number="addNumOfRoom"
                          v-numeric-only
                          type="number"
                          class=""
                        />
                      </validation-provider>
                    </validation-observer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogAddRoomAndGuestVisible = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="AddRoomAndGuest">
            Xác nhận
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { exportRegistrationFormApi } from '@/api/export_service/exportService'
// import { notifyError } from '@/utils/toast'
// import { openPdfWindow } from '@/utils/file-handler'
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'

import { CellRenderNumInput } from '@/utils/groupCellRenders.js'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'
import InfoList from '@/components/info-list/InfoList'

import GroupMasterMissionDialog from './components/GroupMasterMissionDialog.vue'
import DepositDialog from './components/DepositDialog.vue'
import RoomListDialog from './components/RoomListDialog.vue'
import SpecialServiceDialog from './components/SpecialServiceDialog.vue'
import UpdateRoomListDialog from './components/UpdateRoomListDialog.vue'
import CustomerDisplayDialog from './components/CustomerDisplayDialog.vue'
import BookingRoomAddChargeTable from '@/components/resources/booking/BookingRoomAddChargeTable.vue'
import BookingRoomAddChargeDialog from '@/components/resources/booking/BookingRoomAddChargeDialog.vue'
import BookingRoomDailyPriceTable from '@/components/resources/booking/BookingRoomDailyPriceTable.vue'
import BookingRoomServiceDialog from '@/components/resources/booking/BookingRoomServiceDialog.vue'
import BookingRoomServiceTable from '@/components/resources/booking/BookingRoomServiceTable.vue'
import { getAllHotels } from '@/api/configuration/hotel/hotel'

import { mapGetters } from 'vuex'

import { getBookingGroupListApi } from '@/api/booking_service/bookingGroupApi'
import { getBookingGroupAvailableRoomLevelListApi } from '@/api/booking_service/bookingGroupApi'
import {
  getSubGroupByGroupIdApi,
  getSubGroupByIdApi,
  getListAgentToExcelApi,
  cancelBookingApi,
  createSubGroupApi,
  updateSubGroupApi,
  deleteSubGroupApi,
  getGroupBalanceApi
} from '@/api/booking_service/bookingGroup'
import { getReasonCancelApi } from '@/api/Service_Policy/reasonCancel'
import { generateDailyPriceApi } from '@/api/booking_service/booking'
import { getAllCurrencyApi } from '@/api/common/currency'

export default {
  components: {
    Breadcrumb,
    InfoList,
    InfoListLabel,
    InfoListValue,
    // eslint-disable-next-line vue/no-unused-components
    SingleCalendar,
    GroupMasterMissionDialog,
    DepositDialog,
    RoomListDialog,
    CustomerDisplayDialog,
    CalendarSelect,
    CalendarRange,
    CellRenderNumInput,
    SpecialServiceDialog,
    UpdateRoomListDialog,
    BookingRoomAddChargeTable,
    BookingRoomAddChargeDialog,
    BookingRoomDailyPriceTable,
    BookingRoomServiceDialog,
    BookingRoomServiceTable
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      context: null,
      createSub: false,
      reservationStatusList: [
        { value: 1, name: 'Definite' },
        { value: 2, name: 'Tentative' },
        { value: 3, name: 'Seri Booking' },
        { value: 4, name: 'Waiting' }
      ],

      groupStatusList: [
        { value: 2, name: 'Có khách đang ở' },
        { value: 3, name: 'Gồm đoàn trả phòng' },
        { value: 4, name: 'Đoàn bị hủy' }
      ],

      searchParams: {
        info: null,
        agent: null,
        firstArrivalFrom: null,
        firstArrivalTo: null,
        lastDepDateFrom: null,
        lastDepDateTo: null,
        pageSize: 10,
        pageNum: 1,
        orderBy: null,
        orderTp: 'ASC',
        isRoomBooking: true,
        isRoomCo: false,
        isCancel: false,
        isRoomCi: true
      },
      searchParamsDefault: {
        info: null,
        agent: null,
        firstArrivalFrom: null,
        firstArrivalTo: null,
        lastDepDateFrom: null,
        lastDepDateTo: null,
        pageSize: 10,
        pageNum: 1,
        orderBy: null,
        orderTp: 'ASC',
        isRoomBooking: true,
        isRoomCo: false,
        isCancel: false,
        isRoomCi: true
      },
      firstArrival: {},
      lastDep: {},
      isFirstArrivalDate: false,
      isLastDepDate: false,

      dialogMissionVisible: false,
      dialogDepositVisible: false,
      dialogCancelGroupVisible: false,
      dialogRoomListVisible: false,
      dialogSpecialServiceVisible: false,
      dialogUpdateRoomVisible: false,
      dialogCustomerDisplayVisible: false,
      isAddChargeDialogOpened: false,
      dialogAddRoomAndGuestVisible: false,

      subGroupRegisterView: false,
      pinnedBottomRowData: [],
      columns: [
        {
          headerName: 'Hạng phòng',
          headerTooltip: 'Hạng phòng',
          tooltipField: 'room_type_name',
          field: 'room_type_name',
          minWidth: 150
        },
        {
          headerName: 'Số  phòng',
          headerTooltip: 'Số  phòng',
          tooltipField: 'num_of_room',
          field: 'num_of_room',
          minWidth: 100
        },
        {
          headerName: 'Đã chọn phòng',
          headerTooltip: 'Đã chọn phòng',
          tooltipField: 'assign_rooms',
          minWidth: 100,
          field: 'assign_rooms'
        },
        {
          headerName: 'Số khách',
          headerTooltip: 'Số khách',
          tooltipField: 'num_of_guest',
          field: 'num_of_guest',
          minWidth: 100
        },
        // {
        //   headerName: 'Số khách đã chọn phòng',
        //   headerTooltip: 'Số khách đã chọn phòng',
        //   tooltipField: 'assign_guest',
        //   minWidth: 100,
        //   field: 'assign_guest'
        // },
        {
          headerName: 'Từ ngày',
          tooltipField: 'arrive_date',
          field: 'arrive_date',
          valueFormatter: params => {
            if (params.value)
              return this.$moment(params.value).format('DD-MM-YYYY')
          },
          minWidth: 120
        },
        {
          headerName: 'Đến ngày',
          tooltipField: 'depart_date',
          valueFormatter: params => {
            if (params.value)
              return this.$moment(params.value).format('DD-MM-YYYY')
          },
          field: 'depart_date',
          minWidth: 120
        },

        {
          headerName: 'Tổng tiền phòng',
          headerTooltip: 'Tổng tiền phòng',
          // tooltipField: 'total_room_price',
          minWidth: 100,
          field: 'total_room_price',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right'
        },
        {
          headerName: 'Tồng tiền dịch vụ',
          headerTooltip: 'Tồng tiền dịch vụ',
          // tooltipField: 'total_service_price',
          minWidth: 120,
          field: 'total_service_price',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right'
        },

        {
          headerName: 'Tồng tiền',
          headerTooltip: 'Tồng tiền',
          // tooltipField: 'total',
          minWidth: 100,
          field: 'total',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right'
        }
      ],
      rows: [],
      masterGroupCols: [
        {
          headerName: 'STT',
          field: 'no',
          tooltipField: 'no',
          minWidth: 60,
          maxWidth: 60
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          valueGetter: params => {
            if (params.data.status == 1) {
              return 'Đã đặt'
            } else if (params.data.status == 2) {
              return 'Đang ở'
            } else if (params.data.status == 3) {
              return 'Đã trả phòng'
            } else if (params.data.status == 4) {
              return 'Đã hủy'
            }
          },
          minWidth: 100
        },
        // {
        //   headerName: 'Xác nhận',
        //   field: 'confirm_code',
        //   tooltipField: 'confirm_code',
        //   minWidth: 100
        // },
        {
          headerName: 'Mã đoàn',
          field: 'booking_code',
          tooltipField: 'booking_code',
          minWidth: 100
        },
        {
          headerName: 'Tên đoàn',
          field: 'name',
          tooltipField: 'name',
          minWidth: 100
        },
        {
          headerName: 'Đại lý du lịch',
          headerTooltip: 'Đại lý du lịch',
          tooltipField: 'agent_name',
          field: 'agent_name',
          minWidth: 100
        },
        {
          headerName: 'Ngày đến đầu',
          headerTooltip: 'Ngày đến đầu',
          // tooltipField: 'first_arrival_date',
          field: 'first_arrival_date',
          minWidth: 100,
          cellRenderer: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          },
          tooltipValueGetter: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          }
        },
        {
          headerName: 'Ngày đi cuối',
          headerTooltip: 'Ngày đi cuối',
          // tooltipField: 'last_departure_date',
          field: 'last_departure_date',
          minWidth: 100,
          cellRenderer: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          },
          tooltipValueGetter: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          }
        },
        {
          headerName: 'Người tạo',
          tooltipField: 'code',
          field: 'user_create',
          minWidth: 100
          // width: 100
        },
        {
          headerName: 'Thời gian tạo',
          headerTooltip: 'Thời gian tạo',
          // tooltipField: 'create_date',
          field: 'create_date',
          minWidth: 100,
          cellRenderer: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          },
          tooltipValueGetter: params => {
            return params.value
            // ? this.$moment(params.value).format('YYYY-MM-DD')
            // : null
          }
        },
        {
          headerName: 'Ghi chú',
          tooltipField: 'note',
          field: 'note',
          minWidth: 100
          // width: 100
        }
      ],
      masterGroupRows: [],
      masterGroupPaging: {
        totalPage: 0,
        currentPage: 0
      },
      subGroupPaging: {
        totalPage: 0,
        currentPage: 0
      },
      masterGroupLoading: false,
      subGroupLoading: false,
      masterGroupRowSelected: null,
      // GRID API
      masterGroupGridApi: null,

      subGroupSearchParams: {
        id: null
      },

      roomCols: [
        {
          headerName: 'Phòng',
          field: 'no',
          sortable: false,
          // maxWidth: 70,
          minWidth: 70
        },
        {
          headerName: 'Số NL',
          headerTooltip: 'Số người lớn',
          field: 'num_of_adult',
          sortable: false,
          cellRenderer: 'CellRenderNumInput',
          cellRendererParams: params => {
            return {
              type: 'number',
              colName: 'num_of_adult',
              disabled:
                params.data.code !== null &&
                params.data.code !== undefined &&
                params.data.code !== ''
            }
          },
          minWidth: 80
        },
        {
          headerName: 'Số TE',
          headerTooltip: 'Số trẻ em',
          field: 'child_num',
          sortable: false,
          cellRenderer: 'CellRenderNumInput',
          cellRendererParams: params => {
            return {
              type: 'number',
              colName: 'child_num',
              disabled:
                params.data.code !== null &&
                params.data.code !== undefined &&
                params.data.code !== ''
            }
          },
          minWidth: 80
        },
        {
          headerName: 'Số TED5T',
          headerTooltip: 'Số trẻ em dưới 5 tuổi',
          field: 'u5_child_num',
          sortable: false,
          cellRenderer: 'CellRenderNumInput',
          cellRendererParams: params => {
            return {
              type: 'number',
              colName: 'u5_child_num',
              disabled:
                params.data.code !== null &&
                params.data.code !== undefined &&
                params.data.code !== ''
            }
          },
          minWidth: 80
        },
        {
          headerName: '',
          field: '',
          minWidth: 100,
          sortable: false,
          cellRenderer: params => {
            const button = document.createElement('button')
            button.innerHTML = 'Xóa'
            button.className = 'btn primary small'
            if (
              params.data.code !== null &&
              params.data.code !== undefined &&
              params.data.code !== ''
            ) {
              button.disabled = true
            } else {
              button.addEventListener('click', function () {
                params.deleteRow()
              })
            }
            return button
          },
          cellRendererParams: params => {
            return {
              deleteRow: () => {
                this.removeRoomRow(params.data.no)
              }
            }
          }
        }
      ],
      roomRows: [],
      addNumOfRoom: null,
      addNumOfGuest: null,

      roomLevelOptionsCol: [
        {
          headerName: 'Tên',
          field: 'room_type_name',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng',
          field: 'total_room',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng trống',
          field: 'room_available_num',
          // cellClass: "grid-cell-centered",
          flex: 3
        }
      ],
      hotelOptions: [],
      hotel_id: null,

      // cancel group
      cancelReasonList: [],
      cancelGroupExplaination: '',
      cancelReasonColumns: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'reason',
          tooltipField: 'reason',
          minWidth: 100
        }
      ],
      groupBalance: 0,

      // sub group update and regis params
      oldSubGroup: {},
      subGroupForm: {
        code: '',
        id: 0,

        nett: true,
        is_bf: false,
        // block_room: false,

        price_type: 0,
        exchange_rate: 0,

        room_type_id: null,
        // price_code_id: null,
        arrive_date: this.$moment().format('YYYY-MM-DD'),
        depart_date: this.$moment().add(1, 'd').format('YYYY-MM-DD'),
        arrival_time: {
          HH: '14',
          mm: '00'
        },
        depart_time: {
          HH: '12',
          mm: '00'
        },
        people_num: 0,

        num_of_free_card: 2,
        num_of_room: 0,
        num_of_guest: 0,
        num_of_night: 1,
        num_of_adult: 0,
        child_num: 0,
        u5_child_num: 0,

        currency_id: null,
        booking_group_id: null,

        sub_booking_group_surcharges: [],
        sub_booking_group_services: [],
        booking_room: [],
        daily_price: []
      },
      subGroupFormDefault: {
        code: '',
        id: 0,

        nett: true,
        is_bf: false,
        // block_room: false,

        price_type: 0,
        exchange_rate: 0,

        room_type_id: null,
        // price_code_id: null,
        arrive_date: this.$moment().format('YYYY-MM-DD'),
        depart_date: this.$moment().add(1, 'd').format('YYYY-MM-DD'),
        arrival_time: {
          HH: '14',
          mm: '00'
        },
        depart_time: {
          HH: '12',
          mm: '00'
        },

        num_of_free_card: 2,
        num_of_room: 0,
        num_of_guest: 0,
        num_of_night: 1,
        num_of_adult: 0,
        child_num: 0,
        u5_child_num: 0,

        currency_id: null,
        booking_group_id: null,

        sub_booking_group_surcharges: [],
        sub_booking_group_services: [],
        booking_room: [],
        daily_price: []
      },
      // isUpdateForAll: false,

      currencyOptions: [],
      roomLevelOptions: [],
      discountTypeList: [
        {
          label: 'Giảm giá %',
          value: 2
        },
        {
          label: 'Giảm giá tiền ',
          value: 1
        }
      ],

      selectedSubGroup: null
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  computed: {
    ...mapGetters('app', {
      routeData: 'getRouteData'
    }),
    subGroupFormnum_of_room() {
      return this.subGroupForm.num_of_room
    },
    statusGroup() {
      return this.masterGroupRowSelected?.status != 4
    },
    isBuffetDisabled() {
      return this.hotel_id !== 45
    },
    numberOfNights() {
      const oneDay = 24 * 60 * 60 * 1000

      const numberOfNight = Math.round(
        Math.abs(
          (new Date(this.subGroupForm.depart_date) -
            new Date(this.subGroupForm.arrive_date)) /
            oneDay
        )
      )
      return numberOfNight === 0 ? 1 : numberOfNight
    },
    totalGuestsNumber() {
      return (
        Number(this.subGroupForm.num_of_guest) +
        Number(this.subGroupForm.u5_child_num) +
        Number(this.subGroupForm.child_num)
      )
    },

    filteredRoomLevelOptions() {
      if (this.hotel_id == null || this.hotel_id === '') {
        return this.roomLevelOptions
      }
      return this.roomLevelOptions.filter(
        room => room.hotel_id === this.hotel_id
      )
    }
  },

  mounted() {
    this.fnSearchGroupList()
    this.masterGroupGridApi = this.$refs.masterGroupTable.gridApi
    this.getCurrencyList()
    this.fnGetCancelReasonList()
    this.getHotelOptions()
  },
  watch: {
    'subGroupForm.arrive_date': {
      handler() {
        if (this.subGroupForm.depart_date < this.subGroupForm.arrive_date) {
          this.subGroupForm.depart_date = this.$moment(
            this.subGroupForm.arrive_date
          ).format('YYYY-MM-DD')
        }
        this.onChangeBookingDate()
      }
    },
    'subGroupForm.depart_date': {
      handler() {
        this.onChangeBookingDate()
      }
    },
    // 'subGroupForm.arrival_time': {
    //   handler() {
    //     this.onChangeBookingDate()
    //   },
    //   deep: true
    // },
    // 'subGroupForm.depart_time': {
    //   handler() {
    //     this.onChangeBookingDate()
    //   },
    //   deep: true
    // },
    'subGroupForm.people_num'(newValue, oldValue) {
      this.subGroupForm.num_of_guest = this.subGroupForm.num_of_room * newValue
      this.subGroupForm.num_of_adult = this.subGroupForm.num_of_room * newValue
    },

    'subGroupForm.num_of_room'(newValue, oldValue) {
      if (newValue < 1) {
        // this.subGroupForm.num_of_room = oldValue
        return
      }
      if (!this.createSub) {
        if (newValue < this.oldSubGroup.num_of_room) {
          //   this.subGroupForm.num_of_room = this.oldSubGroup.num_of_room
          return
        }
      }
      // this.roomRows = []
      if (this.createSub) {
        if (oldValue > newValue) {
          this.roomRows = this.roomRows.splice(0, newValue)
          this.subGroupForm.num_of_guest =
            newValue * this.subGroupForm.people_num
        }

        // new add sub group dont has this case
        else if (oldValue < newValue) {
          for (let i = oldValue; i < newValue; i++) {
            this.roomRows.push({
              room_type_id: 0,
              child_booking_group_id: 0,
              code: '',
              room_id: 0,
              room_num: '',
              no: i + 1,
              num_of_adult: this.subGroupForm.people_num,
              child_num: 0,
              u5_child_num: 0
            })
          }
        }
      } else {
        if (oldValue > newValue) {
          // new add sub group dont has this case
          this.roomRows = this.roomRows.splice(0, newValue)
        } else if (oldValue < newValue) {
          for (let i = oldValue; i < newValue; i++) {
            this.roomRows.push({
              room_type_id: 0,
              child_booking_group_id: 0,
              code: '',
              room_id: 0,
              room_num: '',
              no: i + 1,
              num_of_adult: this.subGroupForm.people_num,
              child_num: 0,
              u5_child_num: 0
            })
          }
        }
      }
    },
    subGroupRegisterView(newValue, oldValue) {
      this.getRoomTypeOptions()
    },
    // 'subGroupForm.room_type_id'(newValue, oldValue) {
    //   if (newValue === null) return
    //   this.getDailyPrice()
    // },
    // 'subGroupForm.price_type'(newValue, oldValue) {
    //   if (newValue !== null) {
    //     this.$refs.daysTable.gridOptions.api.forEachNode(node => {
    //       {
    //         node.setData(node.data)
    //       }
    //     })
    //   }
    // },
    roomRows: {
      handler: function (newValue, oldValue) {
        this.subGroupForm.num_of_adult = 0
        this.subGroupForm.child_num = 0
        this.subGroupForm.u5_child_num = 0
        newValue.map(item => {
          this.subGroupForm.num_of_adult += item.num_of_adult
          this.subGroupForm.child_num += item.child_num
          this.subGroupForm.u5_child_num += item.u5_child_num
        })
        this.subGroupForm.num_of_guest =
          this.subGroupForm.num_of_adult +
          this.subGroupForm.child_num +
          this.subGroupForm.u5_child_num
      },
      deep: true
    }
  },
  methods: {
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    onPageChanged(pageNum, field) {
      switch (field) {
        case 'masterGroupPaging':
          this.searchParams.pageNum = pageNum
          this.fnSearchGroupList()
          break
        case 'subGroupPaging':
          this.subGroupSearchParams.pageNum = pageNum
          this.fnSearchGroupList()
          break
        default:
          break
      }
    },
    onPageSizeChanged(pageSize, field) {
      switch (field) {
        case 'masterGroupPaging':
          this.searchParams.pageSize = pageSize
          this.searchParams.pageNum = 1
          this.fnSearchGroupList()
          break
        case 'subGroupPaging':
          this.subGroupSearchParams.pageSize = pageSize
          this.subGroupSearchParams.pageNum = 1
          this.fnSearchSubGroupList()
          break
        default:
          break
      }
    },

    async fnSearchGroupList() {
      this.pinnedBottomRowData = []
      this.masterGroupLoading = true
      this.searchParams.firstArrivalFrom = this.firstArrival.start
      this.searchParams.firstArrivalTo = this.firstArrival.end
      this.searchParams.lastDepDateFrom = this.lastDep.start
      this.searchParams.lastDepDateTo = this.lastDep.end

      await getBookingGroupListApi(this.searchParams)
        .then(res => {
          this.masterGroupRows = res.data
          this.masterGroupPaging.totalPage = Math.ceil(
            res.total / this.searchParams.pageSize
          )
          this.masterGroupPaging.currentPage = this.searchParams.pageNum
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.masterGroupRowSelected = null
          this.selectedSubGroup = null
          this.rows = []
          this.masterGroupLoading = false
        })
    },
    onReset() {
      this.searchParams = Object.assign(
        this.searchParams,
        this.searchParamsDefault
      )
      this.firstArrival = { firstArrivalFrom: null, firstArrivalTo: null }
      this.lastDep = { lastDepDateFrom: null, lastDepDateTo: null }
      this.fnSearchGroupList()
    },

    // sub group list
    async fnSearchSubGroupList() {
      this.subGroupLoading = true
      await getSubGroupByGroupIdApi(this.subGroupSearchParams)
        .then(res => {
          this.rows = res.data
          this.subGroupPaging.totalPage = Math.ceil(
            res.total / this.subGroupSearchParams.pageSize
          )
          this.subGroupPaging.currentPage = this.subGroupSearchParams.pageNum
          this.pinnedBottomRowData = [
            {
              room_type_name: 'Tổng cộng',
              num_of_room: res.total_room,
              assign_rooms: res.total_assigned_room,
              num_of_guest: res.total_guest,
              total_room_price: res.total_room_charge,
              total_service_price: res.total_service,
              total: res.total_price
            }
          ]
        })
        .finally(() => {
          this.subGroupLoading = false
        })
    },

    /* TABLE */
    onSelectMasterGroup(selectedRows) {
      this.masterGroupRowSelected = selectedRows[0]
      this.subGroupSearchParams.id = this.masterGroupRowSelected.id
      this.selectedSubGroup = null
      this.fnSearchSubGroupList()
    },

    /* SHOW DIALOG */
    fnOpenMissionDialog() {
      this.dialogMissionVisible = true
    },
    fnOpenCancelGroupDialog() {
      this.fnGetGroupBalance()
      this.dialogCancelGroupVisible = true
    },

    handlePrintRegForm() {
      // exportRegistrationFormApi({
      //   bookingCode: this.masterGroupRowSelected.booking_code
      // })
      //   .then(res => {
      //     openPdfWindow(res)
      //   })
      //   .catch(err => {
      //     notifyError(err.response?.data?.message)
      //   })
      const routeData = this.$router.resolve({
        path: '/group/register_form',
        query: {
          id: this.masterGroupRowSelected.id,
          type: 2
        }
      })
      window.open(routeData.href, '_blank')
    },

    // 4 buttons on top page
    // redirect
    redirectToGroupTransactions() {
      this.$router.push({ path: '/group/group_transactions' })
    },
    async fnStoreRouteData({ to, from }) {
      const params = {
        ...to.params,
        id: this.masterGroupRowSelected?.id
      }
      const routeData = {
        ...to,
        from,
        params
      }
      this.$store.dispatch('app/setRouteData', routeData)
    },
    fnExportExcel() {
      // alert('export excel')
      var date = this.$moment().format('DD-MM-YY')
      getListAgentToExcelApi(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'LIST_GROUP_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },

    // cancel group part
    async fnGetGroupBalance() {
      await getGroupBalanceApi(this.masterGroupRowSelected.id)
        .then(res => {
          this.groupBalance = res.data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnGetRoomList()
        })
    },
    async fnGetCancelReasonList() {
      const data = await getReasonCancelApi({ status: true })
      this.cancelReasonList = data.data ?? []
    },
    onSelectRowCancelReason(val) {
      this.cancelGroupExplaination = val.id
    },
    onCloseCancelGroup() {
      this.dialogCancelGroupVisible = false
      this.fnSearchGroupList()
      this.cancelGroupExplaination = null
    },
    async confirmCancelGroup() {
      // alert('Hủy group thành công!' + this.cancelGroupExplaination)
      if (
        (await this.$vxForm.isValid(this.$refs.cancelGroupFormValidator)) ==
        false
      )
        return
      var params = {
        id: this.masterGroupRowSelected.id,
        cancel_reason: this.cancelGroupExplaination
      }
      await cancelBookingApi(params)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Hủy đoàn thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.dialogCancelGroupVisible = false
          this.cancelGroupExplaination = null
          // this.fnSearchGroupList()
        })
    },
    // end cancel group part

    handleCloseDialog(dialog, reloadRequired = false) {
      this.fnSearchSubGroupList()
      switch (dialog) {
        case 'mission':
          this.dialogMissionVisible = false
          // this.fnSearchGroupList()
          break
        case 'deposit':
          this.dialogDepositVisible = false
          // this.fnSearchGroupList()
          break
        case 'roomList':
          this.dialogRoomListVisible = false
          this.fnSearchGroupList()
          break
        case 'updateRoomBooking':
          this.dialogUpdateRoomVisible = false
          this.fnSearchSubGroupList()
          break
        case 'displayCustomer':
          this.dialogCustomerDisplayVisible = false
          break
        default:
          break
      }
    },

    changeGroupInfo() {
      this.$router.push({
        path: '/group/new_group_master',
        query: { id: this.masterGroupRowSelected.id, action: 'edit' }
      })
      // )
      // this.$router.push('/group/detail_group_master')
    },

    // sub group function
    async onCreateUpdateSubGroup(isUpdateForAll = true) {
      // TODO validate step
      if (
        (await this.$vxForm.isValid(this.$refs.subGroupFormValidator)) == false
      )
        return
      if (this.subGroupForm.daily_price.length === 0) {
        this.$message({
          type: 'error',
          message: 'Vui lòng kiểm tra lại giá phòng'
        })
        return
      }

      this.roomRows = this.roomRows.map(item => {
        return {
          ...item,
          // + item.child_num
          num_of_guest: item.num_of_adult
        }
      })

      this.subGroupForm.booking_room = this.roomRows.filter(
        item =>
          item.code === null || item.code === undefined || item.code === ''
      )
      this.subGroupForm.booking_group_id = this.masterGroupRowSelected.id
      var params = {
        ...this.subGroupForm,
        arrive_date: `${this.subGroupForm.arrive_date} ${this.subGroupForm.arrival_time.HH}:${this.subGroupForm.arrival_time.mm}`,
        depart_date: `${this.subGroupForm.depart_date} ${this.subGroupForm.depart_time.HH}:${this.subGroupForm.depart_time.mm}`,
        arrival_time: `${this.subGroupForm.arrival_time.HH}:${this.subGroupForm.arrival_time.mm}`,
        depart_time: `${this.subGroupForm.depart_time.HH}:${this.subGroupForm.depart_time.mm}`,
        num_of_night: this.numberOfNights
      }
      if (this.createSub) {
        await createSubGroupApi(params)
          .then(data => {
            this.$message({
              type: 'success',
              message: this.$t('successMsg.' + data.message)
            })
            // this.form = { ...this.defaultForm }
            // this.getSubGroup()
            this.subGroupRegisterView = false
            this.fnSearchSubGroupList()
            this.roomRows = [
              {
                room_type_id: 0,
                child_booking_group_id: 0,
                code: '',
                id: 0,
                room_id: 0,
                room_num: '',
                no: 1,
                num_of_adult: 0,
                child_num: 0,
                u5_child_num: 0
              }
            ]
            this.subGroupForm = Object.assign({}, this.subGroupFormDefault)
          })
          .catch(error => {
            this.$message({
              type: 'error',
              message: this.$t('errorMsg.' + error.response.data.message)
            })
          })
          .finally(() => {
            // this.$router.push({ path: 'group_master_functions' })
          })
      } else {
        await updateSubGroupApi(
          this.subGroupForm.id,
          { isUpdateForAll: isUpdateForAll },
          params
        )
          .then(data => {
            this.$message({
              type: 'success',
              message: this.$t('successMsg.' + data.message)
            })
            // this.form = { ...this.defaultForm }
            // this.getSubGroup()
            this.subGroupRegisterView = false
            this.fnSearchGroupList()
            this.roomRows = []
            this.subGroupForm = Object.assign({}, this.subGroupFormDefault)
          })
          .catch(error => {
            this.$message({
              type: 'error',
              message: this.$t('errorMsg.' + error.response.data.message)
            })
          })
          .finally(() => {})
      }
      // call api
    },

    // sub group select option api
    async getCurrencyList() {
      let data = await getAllCurrencyApi()
      this.currencyOptions = data.data
    },
    onChangeCurrency(value) {
      // const currency = this.currencyOptions.find(item => item.id === value)
      this.subGroupForm.currency_id = value
      // this.subGroupForm.exchange_rate = currency.exchange_rate
    },

    async getHotelOptions() {
      await getAllHotels().then(response => {
        this.hotelOptions = response.data
      })
    },
    onChangeHotel() {
      this.subGroupForm.is_bf = false
      this.onChangeRoomLevel()
    },
    async onChangeRoomLevel(value = null) {
      console.log('groupMaster', value)
      if (value != null) {
        this.subGroupForm.room_type_id = value.room_level_id
        this.subGroupForm.people_num = value.people_num
        this.subGroupForm.num_of_free_card = value.free_card_quantity
        this.hotel_id = value.hotel_id
        this.subGroupForm.sub_booking_group_surcharges = []
        this.roomRows.map(it => {
          it.num_of_adult = value.people_num
          it.child_num = 0
          it.u5_child_num = 0
        })
        this.refreshAddRoomTable()
        // this.subGroupForm.num_of_guest = value.people_num
      } else {
        this.subGroupForm.room_type_id = null
        this.subGroupForm.people_num = 0
        this.roomRows.map(it => {
          it.num_of_adult = 0
          it.child_num = 0
          it.u5_child_num = 0
        })
        this.refreshAddRoomTable()
      }
      await this.getDailyPrice().then(() => {})
    },
    refreshAddRoomTable() {
      this.$refs.AddRoomTable.gridOptions.api.refreshCells({
        force: true
      })
    },

    onChangeBuffet() {
      if (
        this.subGroupForm.room_type_id &&
        this.subGroupForm.arrive_date &&
        this.subGroupForm.depart_date
      ) {
        this.getDailyPrice()
      }
    },

    getRowClass(params) {
      let color = null

      const hotelId = params.data.hotel_id
      switch (hotelId) {
        // Khách sạn đoàn tàu
        case 46:
          color = 'green'
          break
        // Khu cắm trại
        case 45:
          color = 'yellow'
          break
        // Làng cổ tích
        case 44:
          color = 'red'
          break
        // Nebula
        case 47:
          color = 'purple'
          break
        // Nhà sàn thái
        case 48:
        default:
          color = 'brown'
          break
      }
      return 'room-level-row room-level-row--' + color
    },
    async getRoomTypeOptions() {
      const query = {
        dateFrom: `${this.subGroupForm.arrive_date} ${this.subGroupForm.arrival_time.HH}:${this.subGroupForm.arrival_time.mm}`,
        dateTo: `${this.subGroupForm.depart_date} ${this.subGroupForm.depart_time.HH}:${this.subGroupForm.depart_time.mm}`
      }
      await getBookingGroupAvailableRoomLevelListApi(query)
        .then(res => {
          this.roomLevelOptions = res.data
            .map(type => {
              type.room_type_name = type.room_level_name
              return type
            })
            .sort((level1, level2) => {
              if (level1.hotel_id > level2.hotel_id) {
                return -1
              } else if (level1.hotel_id < level2.hotel_id) {
                return 1
              }
              return 0
            })
        })
        .catch(err => {
          const message = err?.response?.data?.data.message
          this.$message({
            type: 'error',
            message: message
          })
        })
    },
    async onChangeBookingDate() {
      await this.getRoomTypeOptions()
      await this.getDailyPrice()
    },
    async getDailyPrice() {
      if (this.subGroupForm.room_type_id == null) {
        return
      }
      // if()
      return generateDailyPriceApi(
        this.subGroupForm.arrive_date,
        this.subGroupForm.depart_date,
        this.subGroupForm.room_type_id,
        this.subGroupForm.is_bf
      )
        .then(res => {
          this.subGroupForm.daily_price = res.data.map(day => {
            return {
              id: 0,
              price: day.price,
              date: day.date,
              note: null,
              price_code_id: day.price_code_id,
              price_code: day.price_code,
              nett: day.nett,
              currency_id: day.currency_id,
              currency_code: day.currency_code,
              exchange_rate: day.exchange_rate,
              percent_discount: day.percent_discount,
              amount_discount: day.amount_discount,
              discount_reason: day.discount_reason
            }
          })
          this.$message({
            type: 'success',
            message: 'Đã cập nhật chi tiết giá ngày.'
          })
        })
        .catch(err => {
          throw err
        })
    },

    confirmSpecialService() {
      // this.subGroupForm.sub_booking_group_services = val
      // this.$refs.agGridService.gridOptions.api.refreshCells({
      //   force: true
      // })
      const payload = this.$refs.BookingRoomServiceDialog.dehydrateTable()
      this.subGroupForm.sub_booking_group_services = payload
      this.dialogSpecialServiceVisible = false
    },
    onConfirmAddCharge() {
      const payload = this.$refs.BookingRoomAddChargeDialog.dehydrateTable()
      this.subGroupForm.sub_booking_group_surcharges = payload
      this.isAddChargeDialogOpened = false
    },
    onOpenBookingAddChargeDialog() {
      this.isAddChargeDialogOpened = true
    },

    onOpenAddRoomAndGuestDialog() {
      this.dialogAddRoomAndGuestVisible = true
    },
    AddRoomAndGuest() {
      if (this.addNumOfRoom >= 0) {
        this.subGroupForm.num_of_guest +=
          this.addNumOfRoom * this.subGroupForm.people_num
        this.subGroupForm.num_of_adult +=
          this.addNumOfRoom * this.subGroupForm.people_num
        this.subGroupForm.num_of_room += this.addNumOfRoom
        this.dialogAddRoomAndGuestVisible = false
        // this.addNumOfGuest = null
        this.addNumOfRoom = null
      } else {
        this.$message({
          type: 'error',
          message: 'Vui lòng xem lại thông tin'
        })
      }
    },
    removeRoomRow(no) {
      // this.subGroupForm.num_of_guest = 0
      this.roomRows = this.roomRows
        .filter(item => {
          if (item.no === no)
            this.subGroupForm.num_of_guest =
              this.subGroupForm.num_of_guest -
              (item.num_of_adult + item.child_num + item.u5_child_num)
          return item.no !== no
        })
        .map((item2, index) => {
          return {
            ...item2,
            no: index + 1
          }
        })
      this.subGroupForm.num_of_room = this.roomRows.length
    },

    //
    onSelectSubGroup(selectedRows) {
      this.selectedSubGroup = selectedRows[0]
    },
    onCreateSubGroup() {
      this.createSub = true
      this.subGroupForm.currency_id = this.currencyOptions[0].id
      this.subGroupRegisterView = true
    },
    async onUpdateSubGroup() {
      this.createSub = false
      await this.fnGetSubGroupById()
      this.subGroupRegisterView = true
    },
    async fnGetSubGroupById() {
      await getSubGroupByIdApi(this.selectedSubGroup.id)
        .then(res => {
          var data = res.data

          this.subGroupForm = {
            ...data,
            arrival_time: {
              HH: this.$moment(data.arrive_date).format('HH'),
              mm: this.$moment(data.arrive_date).format('mm')
            },
            depart_time: {
              HH: this.$moment(data.depart_date).format('HH'),
              mm: this.$moment(data.depart_date).format('mm')
            },
            arrive_date: this.$moment(data.arrive_date).format('YYYY-MM-DD'),
            depart_date: this.$moment(data.depart_date).format('YYYY-MM-DD')
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.hotel_id = this.subGroupForm.hotel_id
          this.subGroupForm.num_of_adult = this.subGroupForm.num_of_guest
          this.subGroupForm.num_of_guest =
            this.subGroupForm.num_of_adult +
            this.subGroupForm.child_num +
            this.subGroupForm.u5_child_num
          if (this.subGroupForm.booking_room.length !== 0) {
            this.subGroupForm.booking_room = this.subGroupForm.booking_room.map(
              item => {
                return {
                  ...item,
                  num_of_adult: item.num_of_guest // - item.child_num
                }
              }
            )
            this.roomRows = this.subGroupForm.booking_room
          }
          this.oldSubGroup = Object.assign({}, this.subGroupForm)
        })
    },
    onCancelSubGroup() {
      this.roomRows = []
      this.subGroupForm = Object.assign({}, this.subGroupFormDefault)
      this.subGroupRegisterView = false
    },

    //
    async onDeleteSubGroup() {
      await deleteSubGroupApi(this.selectedSubGroup.id)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Xóa đoàn phụ thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.fnSearchSubGroupList()
          // this.fnSearchGroupList()
        })
    },

    onUpdateDailyPriceRow(colName, params, value) {
      const rowIndex = params.rowIndex
      const fieldName = params.colDef.field
      this.subGroupForm.daily_price[rowIndex][fieldName] = value
      if (fieldName === 'percent_discount') {
        this.subGroupForm.daily_price[rowIndex]['amount_discount'] = null
      } else if (fieldName === 'amount_discount') {
        this.subGroupForm.daily_price[rowIndex]['percent_discount'] = null
      }
      // this.$refs.BookingRoomDailyPriceTable.$refs.agGrid.gridOptions.api.refreshCells(
      //   {
      //     force: true
      //   }
      // )
    },

    // component in Cell Render
    SelectInputChange(colName, data, value) {
      const idx = data.rowIndex
      this.subGroupForm.daily_price[idx][colName] = value
      if (colName === 'currency_id') {
        this.subGroupForm.daily_price[idx]['exchange_rate'] =
          this.currencyOptions.filter(item => {
            return item.id === value
          })[0].exchange_rate
      }
      this.$refs.daysTable.gridOptions.api.forEachNode(node => {
        {
          if (node.data.id === data.data.id) node.setData(data.data)
        }
      })
    },
    textInputChange(params, value, colName) {
      const idx = params.rowIndex
      if (colName === 'num_of_adult') {
        this.roomRows[idx][colName] = value
      } else if (colName === 'child_num') {
        this.roomRows[idx][colName] = value
      } else if (colName === 'u5_child_num') {
        this.roomRows[idx][colName] = value
      } else {
        // this.subGroupForm.daily_price[idx][colName] = value
      }
    },
    changeCurrencyInput(params, value, colName) {
      const idx = params.rowIndex
      this.subGroupForm.daily_price[idx][colName] = value
    },

    changeCalendar(params, value, colName) {
      const idx = params.rowIndex
    },

    changeCheckbox(colName, params, value) {
      const idx = params.rowIndex
      this.subGroupForm.daily_price[idx][colName] = value
      this.$refs.daysTable.gridOptions.api.forEachNode(node => {
        {
          if (node.data.id === params.data.id) node.setData(params.data)
        }
      })
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (to.path === '/group/group_transactions') {
      await this.fnStoreRouteData({ to, from })
    }
    next()
  }
}
</script>

<style lang="scss">
.note-area {
  height: 100%;
  width: 100%;
  background: #fff3af;
  padding: 10px;
  border: none;
  &:focus {
    outline: none;
  }
}
.table-custom-1 {
  padding: 10px;
  background: white;
  border: 1px solid #ced4da;
  height: 300px;
}
.button-containers {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.title-1 {
  color: #357456;
  margin: 10px 0;
  font-weight: 700;
  font-size: 14px;
  .customer-name {
    margin-left: 10px;
    color: #dc3545;
  }
}
.customer-name {
  margin-left: 10px;
  color: #dc3545;
}
// .ag-theme-balham .ag-row-selected {
//   background-color: #357456 !important;
// }
.w-0 {
  width: 0%;
}
.w-5 {
  width: 5%;
}
.w-10 {
  width: 10%;
}
.w-15 {
  width: 15%;
}
.w-16 {
  width: 16%;
}
.w-20 {
  width: 20%;
}
.w-25 {
  width: 25%;
}
.w-30 {
  width: 30%;
}
.w-33 {
  width: 33%;
}
.w-50 {
  width: 50%;
}
.w-60 {
  width: 60%;
}
.w-100 {
  width: 100%;
}
.label {
  font-weight: 400 !important;
  line-height: 24px !important;
}
.radio-checkbox-cell {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: end;
  font-size: 16px;
}
.checks-wrap {
  padding: 4px 0;
  font-weight: 400 !important;
  line-height: 24px !important;
  color: #606266 !important;
}
.checkbox-wrap {
  font-weight: 400 !important;
  line-height: 24px !important;
  color: #606266 !important;
}
.custom-price {
  display: flex;
  flex-direction: column;
}
.discount {
  display: flex;
  flex-direction: row;
}
.pr-1 {
  margin-right: 12px !important;
}
.mb-1 {
  margin-bottom: 4px;
}
.mb-3 {
  margin-bottom: 12px;
}
.mb-2 {
  margin-bottom: 8px;
}
// .required::before {
//   content: '*';
//   font-size: 15px;
//   color: red;
//   width: 5px;
//   height: 5px px;
//   position: absolute;
//   top: 0;
//   right: -8px;
// }
.ag-theme-balham .ag-row.room-level-row {
  background-color: var(--room-level-background);
  color: var(--room-level-background--hovered);
  font-weight: 500;
  border-color: transparent;
  &:hover {
    background-color: var(--room-level-background--hovered);
    color: white;
  }

  &--green {
    --room-level-background: rgb(22, 101, 52, 0.1);
    --room-level-background--hovered: rgb(22 101 52);
  }
  &--brown {
    --room-level-background: rgb(113, 63, 18, 0.1);
    --room-level-background--hovered: rgb(113 63 18);
  }
  &--purple {
    --room-level-background: rgba(168, 85, 247, 0.1);
    --room-level-background--hovered: rgb(168, 85, 247);
  }
  &--red {
    --room-level-background: rgba(225, 29, 72, 0.1);
    --room-level-background--hovered: rgb(225 29 72);
  }
  &--yellow {
    --room-level-background: rgba(234, 179, 8, 0.2);
    --room-level-background--hovered: rgb(234 179 8);
  }
}
</style>
